import { Button } from '../../components';
import React from 'react';
import { RolesManagementService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import  '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchDomesList: any;
  setShowOverlay: any;
}

const DomesManagementDelete: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchDomesList,
    setShowOverlay,
  } = props;

  const [deleted, setDeleted] = React.useState(false);
  const deleteDomesService = () => {
    setShowOverlay(true);
    RolesManagementService.deleteRole(id).then(() => {
      setDeleted(true);
      setShowOverlay(false);
    });
  };

  return (
    <>
      {!deleted ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            Delete Role
          </h2>
          <p>
            Are you sure you want to delete this role?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent="danger" onClick={deleteDomesService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Role deleted successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchDomesList({
              page: 1,
              rowsPerPage: 10,
            });
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default DomesManagementDelete;
